<template>
  <div>
    <!-- モバイル版NJCしょーたくん履歴画面-->
    <div v-if="this.display == true" class='margin-option'>
      <p style="text-align:right">{{this.userName}}&emsp;</p>
      <h1>発行済みURL一覧</h1><br><br>
      <router-link  class="float-left pull-right btn btn-primary btn-lg " style="width:150px; height: 50px; color: white;"  to="/">Homeに戻る</router-link>
      <br><br><br>
      <!-- 表データの表示設定
        :columns...列表示
        :rows...行表示
        :search-options...検索機能
          initialSortBy...指定したfieldで並び替え
        :sort-options...並び替え機能
        :pagination-options...ページネーション設定
      -->
      <vue-good-table
        :columns="columns_mobile"
        :rows="this.info"
        :search-options="{
            enabled: true,
            trigger: 'enter',
            skipDiacritics: true,
            placeholder: 'Search this table',
          }"
        :sort-options="{
            enabled: true,
            initialSortBy: {field: 'data', type: 'desc'}
          }"
        :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 10,
            position: 'top',
            perPageDropdown: [50, 100],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
          }"
      >
        <!-- テーブルデータの表示設定-->
        <template slot="table-row" slot-scope="props" >
          <p v-if="props.column.field == 'id'"  @click="click_action(props.row.id)" >https://urls.njc.co.jp/{{props.row.id}}
            <!-- ShortURLを押したときのモーダル設定-->
            <template>
              <b-modal scrollable title="Scrollable Content" v-if="isActive == true && props.row.id == SearchID" v-model="isActive" class='margin-option'>
                <!-- モーダルのヘッダー設定-->
                <template v-slot:modal-header >
                  <a style="font-size: 150%; text-align: center;">https://urls.njc.co.jp/{{props.row.id}}</a>
                  <b-button v-if="(props.row.flag === false )" size="sm" variant="danger" @click="ListClose(props.row.id)">公開中</b-button>
                  <b-button v-else size="sm" variant="danger" @click="ListOpen(props.row.id)">非公開</b-button>
                </template>
                <!-- モーダル内のテーブル設定-->
                <div style="width:100%; border:1px solid #cc0000;">
                  <table border="1" style="table-layout:fixed;width:100%;">
                    <colgroup>
                      <col style="width:25%;">
                      <col style="width:75%;">
                    </colgroup>
                    <tbody>
                    <tr><td>URL</td><td style="word-break : break-all; "><a :href="props.row.url" target="_blank">{{props.row.url}}</a></td></tr>
                    <tr><td>COUNT</td><td>{{props.row.count}}</td></tr>
                    <tr><td>MEMO</td><td style="word-break : break-all; ">{{props.row.memo}}</td></tr>
                    <tr><td>CreatedAt</td><td>{{props.row.data}}</td></tr>
                    </tbody>
                  </table><br>
                  <div style="text-align:center;">
                    <vue-qrcode  v-if="props.row.shortenURL" :value="'https://urls.njc.co.jp/' + props.row.id" :options="option_mobile" tag="img" />
                  </div>
                </div>
                <!-- モーダルのフッター設定-->
                <template v-slot:modal-footer>
                  <b-button size="sm" variant="info" @click="URLChange(props.row.id)">元URL変更</b-button>
                  <b-button size="sm" variant="primary" @click="MEMOChange(props.row.id)">MEMO更新</b-button>
                  <b-button v-if="(props.row.count <= 5 )" size="sm" variant="danger" @click="ListDelete(props.row.id)">削除</b-button>
                  <b-button v-else size="sm" variant="danger" @click="ListNoDelete()">削除</b-button>
                  <b-button size="sm" variant="secondary" @click="close_action()">閉じる</b-button>
                </template>
              </b-modal>
            </template>
          </p>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
            </span>
        </template>
      </vue-good-table>
    </div>
    <!-- ブラウザ版NJCしょーたくん履歴画面-->
    <div  v-if="this.display == false" class='margin-option'>
      <p style="text-align:right">{{this.userName}}&emsp;</p>
      <h1>発行済みURL一覧</h1><br>
      <router-link  class="float-left pull-right btn btn-primary btn-lg " style="width:150px; height: 50px; color: white;"  to="/">Homeに戻る</router-link>
      <br><br><br>
      <vue-good-table
        :columns="columns"
        :rows="this.info"
        :search-options="{
          enabled: true,
          trigger: 'enter',
          skipDiacritics: true,
          placeholder: 'Search this table',
        }"
        :sort-options="{
          enabled: true,
          initialSortBy: {field: 'data', type: 'desc'}
        }"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: 10,
          position: 'top',
          perPageDropdown: [50, 100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'next',
          prevLabel: 'prev',
          rowsPerPageLabel: 'Rows per page',
          ofLabel: 'of',
          pageLabel: 'page',
          allLabel: 'All',
        }"
      >
        <!-- テーブルデータの表示設定-->
        <template slot="table-row" slot-scope="props">
          <p v-if="props.column.field == 'id'">https://urls.njc.co.jp/{{props.row.id}}</p>
          <!-- URLをリンク化し、別タブで表示する-->
          <a style="word-break : break-all;" :href="props.row.url" target="_blank" v-else-if="props.column.field == 'url'">
            {{props.row.url}}
          </a>
          <p style="word-break : break-all;" v-else-if="props.column.field == 'url'" />
          <p v-else-if="props.column.field == 'shortenURL'">
            <vue-qrcode v-if="props.row.shortenURL" :value="'https://urls.njc.co.jp/' + props.row.id" :options="option" tag="img" />
          </p>
          <p v-else-if="props.column.field == 'button'">
            <!-- 元URL変更ボタン-->
            <button class="button_change btn btn-info btn-lg" type="button" @click="URLChange(props.row.id)" >元URL変更</button><br>
            <!-- MEMO更新ボタン-->
            <button class="button_change btn btn-primary btn-lg" type="button" @click="MEMOChange(props.row.id)" >MEMO更新</button><br>
            <!-- 所有者変更ボタン-->
            <button class="button_change btn btn-warning btn-lg" type="button" @click="OwnerChange(props.row.id)" >所有者変更</button><br>
            <!-- 削除ボタン Countが5以下なら削除可能 -->
            <button v-if="(props.row.count <= 5 )" class="button_delete btn btn-danger btn-lg" v-on:click="ListDelete(props.row.id);">
              削除
            </button>
            <!-- 削除ボタン Countが5より大きいなら削除不可 -->
            <button v-else class="button_delete btn btn-secondary btn-lg" v-on:click="ListNoDelete()">
              削除
            </button>
          </p>
          <p v-else-if="props.column.field == 'flag'"  style="margin:10px 5px 10px 5px">
            <button v-if="(props.row.flag === false )" class="button_delete btn btn-danger btn-lg" @click="ListClose(props.row.id);">
              公開中
            </button>
            <button v-else class="button_delete btn btn-secondary btn-lg" @click="ListOpen(props.row.id);">
              非公開
            </button>
          </p>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table><br>
    </div>
  </div>
</template>

<script>
// import VueGoodTable from 'vue-good-table';
import axios from 'axios'
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import {
  EMAIL
} from '../constants'

const config = {headers: {
  'Content-Type': 'application/json',
  'x-api-key': '1qazxsw23edcvfr45tgbnhy67ujm,ki8njc', // 本番環境
  // 'x-api-key': 'lLU7IBRZ7z1GZAGDDMwUS9Fo6E2cOyBZ1r0QqmCh', // dev環境
  'go-api-key': 'bhxvgz996'
}
}

export default {
  name: 'list',
  components: {
    VueGoodTable,
    VueQrcode
  },
  data () {
    return {
      apiUrl: 'https://3weyfv5h45.execute-api.ap-northeast-1.amazonaws.com/api/', // 本番環境
      // apiUrl: 'https://w0bfwyddpl.execute-api.ap-northeast-1.amazonaws.com/ShortURL_dev_test/', // dev環境
      // 列部分の設定
      columns: [
        {
          label: 'ShortenURL',
          field: 'id',
          width: '10%'
        },
        {
          label: 'URL',
          field: 'url',
          width: '25%'
        },
        {
          label: 'COUNT',
          field: 'count',
          type: 'number',
          width: '6%'
        },
        {
          label: 'MEMO',
          field: 'memo',
          width: '20%'
        },
        {
          label: 'Created At',
          field: 'data',
          width: '10%'
        },
        {
          label: 'Last Access Date',
          field: 'LastAccessDateData',
          width: '10%'
        },
        {
          label: 'QR',
          field: 'shortenURL',
          sortable: false,
          tdClass: 'text-center',
          width: '7%'
        },
        {
          label: 'Button',
          field: 'button',
          sortable: false,
          tdClass: 'text-center',
          width: '6%'
        },
        {
          label: 'ON/OFF',
          field: 'flag',
          sortable: false,
          tdClass: 'text-center',
          width: '6%',
          hidden: false
        }
      ],
      columns_mobile: [
        {
          label: 'ShortenURL',
          field: 'id'
        },
        {
          label: 'Created At',
          field: 'data'
        }
      ],
      // 行部分の設定
      info: [{ID: '', URL: '', shortenURL: '', count: '', memo: '', data: '', LastAccessDateData: '', flag: ''}],
      x_token: '',
      SearchID: '',
      isActive: false,
      display: {},
      ChangeURL: '',
      ChangeMEMO: '',
      ChangeOwner: '',
      isOpen: false,
      isClose: true,
      userName: decodeURIComponent(escape(atob(localStorage.getItem(EMAIL)))),
      option: {
        errorCorrectionLevel: 'M',
        maskPattern: 0,
        margin: 3,
        scale: 2,
        width: 125,
        color: {
          dark: '#000000FF',
          light: '#FFFFFFFF'
        }
      },
      option_mobile: {
        errorCorrectionLevel: 'M',
        maskPattern: 0,
        margin: 3,
        scale: 2,
        width: 250,
        color: {
          dark: '#000000FF',
          light: '#FFFFFFFF'
        }
      }
    }
  },
  // /listへアクセスしたときに実行する
  mounted: function () {
    this.ListGet()
    this.handleResize()
  },

  methods: {
    click_action: function (SearchID) {
      console.log(SearchID)
      this.SearchID = SearchID
      console.log(this.isActive)
      this.isActive = true
      console.log(this.isActive)
    },
    close_action: function () {
      console.log(this.isActive)
      this.isActive = false
      console.log(this.isActive)
    },
    // 画面サイズの取得、表示分岐(モバイル版、ブラウザ版)
    handleResize: function () {
      if (window.innerWidth <= 480) {
        this.display = true
        console.log(this.display)
      } else {
        this.display = false
        console.log(this.display)
      }
    },
    // MEMOの更新機能
    MEMOChange (SearchID) {
      this.ChangeMemo = window.prompt('[https://urls.njc.co.jp/' + SearchID + ']のMEMOを以下内容で更新します。')
      if (this.ChangeMemo === '') {
        console.log('未入力でOKを押されました')
        alert('入力欄が空欄です。')
      } else if (this.ChangeMemo === null) {
        console.log('キャンセルが押されました')
      } else {
        // console.log(ChangeMemo)
        console.log(this.ChangeMemo)
        const NewMemo = {memo: this.ChangeMemo}
        axios.put(this.apiUrl + SearchID, NewMemo, config)
          .then(result => {
            console.log(NewMemo)
            alert('[https://urls.njc.co.jp/' + SearchID + ']のMEMOが更新されました')
            location.reload()
          })
          .catch(error => {
          /*eslint-disable*/
            console.error(error);
            /* eslint-enable */
          })
      }
    },
    URLChange (SearchID) {
      this.ChangeURL = window.prompt('[https://urls.njc.co.jp/' + SearchID + ']の元URLを以下の内容に変更します。')
      console.log(this.ChangeURL)
      if (this.ChangeURL === '') {
        console.log('未入力でOKを押されました')
        alert('入力欄が空欄です。')
      } else if (this.ChangeURL === null) {
        console.log('キャンセルが押されました')
      } else {
        console.log('OKを押されました')
        // console.log(ChangeMemo)
        var test = 'https://'
        var test2 = 'http://'
        if ((this.ChangeURL.search(test)) && (this.ChangeURL.search(test2))) {
          console.log('誤入力でOKを押されました')
          alert('入力した内容はURLではありません')
        } else {
          const NewURL = {url: this.ChangeURL}
          axios.put(this.apiUrl + SearchID, NewURL, config)
            .then(result => {
              console.log(result.data['result'])
              console.log(this.ChangeURL)
              console.log(result.data.flag)
              // console.log(NewMemo)
              alert('[https://urls.njc.co.jp/' + SearchID + ']の元URLが変更されました')
              location.reload()
            })
            .catch(error => {
            /*eslint-disable*/
              console.error(error);
              /* eslint-enable */
            })
        }
      }
    },
    OwnerChange (SearchID) {
      this.ChangeOwner = window.prompt('[https://urls.njc.co.jp/' + SearchID + ']のメールアドレスを以下の内容に変更します。')
      console.log(this.ChangeOwner)
      if (this.ChangeOwner === '') {
        console.log('未入力でOKを押されました')
        alert('入力欄が空欄です。')
      } else if (this.ChangeOwner === null) {
        console.log('キャンセルが押されました')
      } else {
        console.log('OKを押されました')
        const mailAddressRegex = /^[a-zA-Z0-9._%+-]+@njc\.co\.jp$/
        if (!mailAddressRegex.test(this.ChangeOwner)) {
          console.log('誤入力でOKを押されました')
          alert('入力した内容はメールアドレスではありません')
        } else {
          const NewOwner = {username: this.ChangeOwner}
          console.log(NewOwner)
          axios.put(this.apiUrl + SearchID, NewOwner, config)
            .then(result => {
              console.log(result.data['result'])
              console.log(this.ChangeOwner)
              console.log(result.data.flag)
              alert('[https://urls.njc.co.jp/' + SearchID + ']の元メールアドレスが変更されました')
              location.reload()
            })
            .catch(error => {
              /*eslint-disable*/
              console.error(error);
              /* eslint-enable */
            })
        }
      }
    },
    // Listの受け取り
    ListGet: function () {
      this.x_token = localStorage.getItem(EMAIL)
      console.log(this.x_token)
      console.log('OK1')
      axios.get(this.apiUrl + 'list/' + this.x_token, config)
        .then((result) => {
          console.log('OK2')
          this.info = result.data['urls']
          /*eslint-disable*/
            console.log(result);
            console.log(this.info);
          /* eslint-enable */
        })
        .catch(error => {
          console.log('OUT!')
          /*eslint-disable*/
            console.error(error);
            /* eslint-enable */
        })
    },
    // データの削除不可機能
    ListNoDelete: function () {
      alert('アクセス回数が6回以上のデータは削除できません')
    },
    // データの削除機能
    ListDelete: function (SearchID) {
      if (confirm('[https://urls.njc.co.jp/' + SearchID + ']を本当に削除してよろしいですか？')) {
        console.log('OK1')
        axios.delete(this.apiUrl + SearchID, config)
          .then(result => {
            console.log('OK2')
            alert('[https://urls.njc.co.jp/' + SearchID + ']が削除されました')
            location.reload()
          })
          .catch(error => {
          /*eslint-disable*/
            console.error(error);
            /* eslint-enable */
          })
      }
    },
    ListClose: function (SearchID) {
      console.log(SearchID)
      console.log(this.isClose)
      const flag = {flag: this.isClose}
      axios.put(this.apiUrl + SearchID, flag, config)
        .then(result => {
          console.log(result.data.flag)
          alert('[https://urls.njc.co.jp/' + SearchID + ']が非公開になりました')
          location.reload()
        })
        .catch(error => {
          /*eslint-disable*/
            console.error(error);
            /* eslint-enable */
        })
    },
    ListOpen: function (SearchID) {
      console.log(SearchID)
      console.log(this.isOpen)
      const flag = {flag: this.isOpen}
      axios.put(this.apiUrl + SearchID, flag, config)
        .then(result => {
          console.log(result.data.flag)
          alert('[https://urls.njc.co.jp/' + SearchID + ']が公開されました')
          location.reload()
        })
        .catch(error => {
          /*eslint-disable*/
            console.error(error);
            /* eslint-enable */
        })
    }
  }
}
</script>

<style scoped>
.ul {
    padding-left: 0;
    font-family: Helvetica, Arial, sans-serif;
}

.staggered-transition {
    transition: all .5s ease;
    overflow: hidden;
    margin: 0;
    height: 20px;
}

.staggered-enter, .staggered-leave {
    opacity: 0;
    height: 0;
}

.margin-option{
  margin: 20px 60px 20px
}

.button_change{
  text-align:center;
  font-weight: 900;
  margin:0px 0px 3px 0px;
  font-size:75%;
  width:100px;
  height: 45px;
}

.button_delete{
  text-align:center;
  font-weight: 700;
  margin:0px 0px 0px 0px;
  font-size:100%;
  width:100px;
  height: 45px;
}

@media screen and (max-width: 480px) {
.Home_button{
  width:150px;
  height: 50px;
  color: white;
}

.margin-option{
  margin: 5px 15px 5px
}

.overlay{
  z-index:1;

  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);

  display: flex;
  align-items: center;
  justify-content: center;

}

.content{
  z-index:2;
  width:50%;
  padding: 1em;
  background:#fff;
}

.modal {
  display: block;
}

}
</style>



// WEBPACK FOOTER //
// src/components/List.vue